export default{
    creatted(el, binding) {
        console.log('Created UNFOCUS....')  ;
    },
    mounted(el, binding) {
        console.log('Created UNFOCUS....')  ;
        el.addEventListener('mouseleave', () => {
            document.activeElement.blur();
        })
        el.addEventListener('click', () => {
            document.activeElement.blur();
        })
    }
}
